export const commonConstant = {
  INCOMPLETE_FUNC_HINT: '功能即将开通...',
  pageTitle: '舒辅智慧心理'
}

export const lobType = {
  EAP: 'EAP',
  CONSULTANT: 'CONSULTANT',
  COMPANY: 'COMPANY',
  SFDA: 'SFDA',
  FENGLIN: 'FENGLIN',
}

export const emitterEvent = {
  APPOINT_UPDATE: 'APPOINT_UPDATE',
  HANG_UP: 'HANG_UP',
  CONSULT_END_CONFIRM: 'CONSULT_END_CONFIRM',
  CONSULT_WAIT_EVALUATE: 'CONSULT_WAIT_EVALUATE',
  STAFF_FORM_TASK_SUCCESS: 'STAFF_FORM_TASK_SUCCESS',
  EVALUATION_REPORT_TO_STAFF: 'EVALUATION_REPORT_TO_STAFF',
  STAFF_FORM_TASK_AI_REPORT: 'STAFF_FORM_TASK_AI_REPORT',
  ACTIVITY_REPORT_GENERATED: 'ACTIVITY_REPORT_GENERATED',
  WORK_ORDER_TOOK: 'WORK_ORDER_TOOK',
  WORK_ORDER_RELEASED: 'WORK_ORDER_RELEASED',
  WORK_ORDER_COMPLETED: 'WORK_ORDER_COMPLETED',
  WORK_ORDER_COMPLETED_BY_CONSULTANT: 'WORK_ORDER_COMPLETED_BY_CONSULTANT',
  WORK_ORDER_CREATED: 'WORK_ORDER_CREATED',
  WORK_ORDER_REOPENED: 'WORK_ORDER_REOPENED',
  ACTIVITY_TEAM_REPORT_GENERATED: ' ACTIVITY_TEAM_REPORT_GENERATED',
  TEAM_ACTIVITY_TODO_UNLOCK: 'TEAM_ACTIVITY_TODO_UNLOCK',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED',
  TEAM_ACTIVITY_COMPLETE: 'TEAM_ACTIVITY_COMPLETE',
  TEAM_ACTIVITY_MEMBER_DOLL_BACK_IMAGE_CREATED: 'TEAM_ACTIVITY_MEMBER_DOLL_BACK_IMAGE_CREATED',
  TEAM_VOTE_ACTIVITY_START: 'TEAM_VOTE_ACTIVITY_START',
  TEAM_VOTE_ACTIVITY_END: 'TEAM_VOTE_ACTIVITY_END',
  TODAY_STORY_IMAGE_GENERATED: 'TODAY_STORY_IMAGE_GENERATED',
}

export const companyOrgIds = ['1', 'minhang', 'szzyjsxy', 'shyyjsdx', 'shhydx'];

// 首页功能列表
export const funcList = {
  'sit_edu': {
    pageTitle: 'SIT学生心理咨询-心理关爱平台',
    funcs: [
      { id: 'personalized-psychologist', title: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
    trainingCall: '400-001-6335',
  },
  'szzyjsxy': {
    funcs: [
      { id: 'personalized-psychologist', title: '专属服务向导' },
      { id: 'ai-psychological-counselor' }, 
      { id: '24-hotline', title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'health-report' },
      { id: 'me' },
    ],
    hotLine: '4000081610',
    trainingCall: '400-001-6335'
  },
  'minhang': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'health-report' },
      { id: 'me' },
    ],
    hotLine: '4000081610',
    trainingCall: '400-001-6335'
  },
  '1': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4008208261',
    trainingCall: '400-001-6335'
  },
  'fafuli': {
    funcs: [
      {
        "id": "banner",
        "imgs": [
          "/config/uiConfig/banner/fafuli_ZGS01/banner_5.jpg",
          "/config/uiConfig/banner/fafuli_ZGS01/banner1.png",
          "/config/uiConfig/banner/fafuli_ZGS01/banner2.png",
          "/config/uiConfig/banner/fafuli_ZGS01/banner3.png"
        ]
      },
      { id: 'personalized-psychologist', nickName: '预约服务' },
      { id: 'ai-psychological-counselor' },
      { id: 'training' },
      { id: 'resource', submenus: ['znlx', 'jysp'] },
      { id: 'form-test' },
      { id: 'znlx' },
      { id: 'jysp' },
      { id: 'health-report' },
      { id: 'me' },
    ],
    hotLine: '4000081610',
    appointCall: '400-001-6335',
    trainingCall: '400-001-6335'
  },
  'baoshijie': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理咨询预约热线', subtitle: '一键拨打预约心理咨询服务', },
      { id: 'training' },
      { id: 'appointment', serviceType: [1, 2], language: [1, 2] },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '400-001-6335'
  },
  '2': {
    funcs: [
      {
        "id": "banner",
        "imgs": [
          "/config/uiConfig/banner/fafuli_ZGS01/banner_5.jpg",
          "/config/uiConfig/banner/fafuli_ZGS01/banner1.png",
          "/config/uiConfig/banner/fafuli_ZGS01/banner2.png",
          "/config/uiConfig/banner/fafuli_ZGS01/banner3.png",
        ]
      },
      { id: 'personalized-psychologist' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test' },
      { id: 'me' },
      { id: 'appointment' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
    appointCall: '400-001-6335',
    trainingCall: '400-001-6335'
  },
  'sh_msa': {
    funcs: [
      { id: 'personalized-psychologist' },
      { id: 'ai-psychological-counselor' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ]
  },
  'huayi': {
    pageTitle: '幸福加油站--心理健康营',
    funcs: [
      { id: 'personalized-psychologist' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'appointment' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
    appointCall: '400-001-6335',
  },
  // 'jingan_police': {
  //   funcs: [ {id: 'personalized-psychologist', nickName: '专属服务向导'}, {id: 'ai-psychological-counselor'}, 
  //    {id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00'}, 
  //    {id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00'}, 
  //    {id: 'training'}, {id: 'resource'}, {id: 'form-test', disabledAITest: true},],
  //   hotLine: '4008208261',
  //   trainingCall: '400-001-6335'
  // },
  'jingan_procuratorate': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: 'training' }, { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4008208261',
    trainingCall: '400-001-6335'
  },
  'jingan_court': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: 'training' }, { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4008208261',
    trainingCall: '400-001-6335'
  },
  'jingan_market_supervision': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4008208261',
    trainingCall: '400-001-6335'
  },
  'jingan_fans': {
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline', title: '心理热线', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: '24-text-consult', title: '图文咨询', subtitle: '9:00 - 21:00', startWorkTime: '9:00', endWorkTime: '21:00' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }],
    hotLine: '4008208261',
    trainingCall: '400-001-6335'
  },
  // 'broadcast240601': {
  //   funcs: [ {id: 'personalized-psychologist', nickName: '专属服务向导'}, {id: 'ai-psychological-counselor'}, 
  //   {id: 'resource'}, {id: 'form-test', disabledAITest: true},{id: 'health-report'}]
  // },
  'demo': {
    funcs: [
      {
        "id": "banner",
        "imgs": [
          "/config/uiConfig/banner/default/banner_1.jpg",
          "/config/uiConfig/banner/default/banner_2.jpg",
          "/config/uiConfig/banner/default/banner_3.jpg",
          "/config/uiConfig/banner/default/banner_4.jpg",
        ]
      },
      { id: 'personalized-psychologist' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '心理热线' },
      { id: '24-text-consult', title: '图文咨询'},
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'appointment' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
    appointCall: '400-001-6335',
    trainingCall: '400-001-6335'
  },
  'wugang': {
    pageTitle: '爱康&舒辅智慧心理',
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: false },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
  },
   'shenxiang': {
    pageTitle: '上药神象职工心理关爱平台',
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-text-consult', title: '24小时图文咨询' },
      { id: '24-hotline', title: '24小时心理热线' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
  },
   'waoboo': {
    pageTitle: '晚宝良品职工心理关爱平台',
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-text-consult', title: '24小时图文咨询' },
      { id: '24-hotline', title: '24小时心理热线' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
  },
   'sh_jiaotongzhiye': {
    pageTitle: '上交院心理关爱平台',
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: true },
      { id: 'me' },
      { id: 'health-report' }
    ],
  },
   'wuhan_jinrong': {
    pageTitle: '武汉市委金融办职工心理关爱平台',
    funcs: [
      { id: 'personalized-psychologist', nickName: '专属服务向导' },
      { id: 'ai-psychological-counselor' },
      { id: '24-text-consult', title: '24小时图文咨询' },
      { id: '24-hotline', title: '24小时心理热线' },
      { id: 'resource' },
      { id: 'form-test', disabledAITest: false },
      { id: 'me' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
  },
  shenzhen_xinxizhiye: {
    "pageTitle": '深信阳光成长平台',
    "funcs": [
      { "id": 'personalized-psychologist', "nickName": '专属服务向导' },
      { "id": 'ai-psychological-counselor' },
      { "id": '24-text-consult', "title": '24小时图文咨询' },
      { "id": '24-hotline', "title": '24小时心理热线' },
      { "id": 'resource' },
      { "id": 'form-test', "disabledAITest": true },
      { "id": 'me' },
      { "id": 'health-report' }
    ],
    "hotLine": '4000081610'
  },
  default: {
    funcs: [
      {
        "id": "banner",
        "imgs": [
          "/config/uiConfig/banner/default/banner_1.jpg",
          "/config/uiConfig/banner/default/banner_2.jpg",
          "/config/uiConfig/banner/default/banner_3.jpg",
          "/config/uiConfig/banner/default/banner_4.jpg",
        ]
      },
      { id: 'personalized-psychologist' },
      { id: 'ai-psychological-counselor' },
      { id: '24-hotline',  title: '24小时心理热线' },
      { id: '24-text-consult',  title: '24小时图文咨询' },
      { id: 'training' },
      { id: 'resource' },
      { id: 'form-test' },
      { id: 'me' },
      { id: 'appointment' },
      { id: 'health-report' }
    ],
    hotLine: '4000081610',
    appointCall: '400-001-6335',
    trainingCall: '400-001-6335'
  }
}

// 使用初始评估（学生版）的机构号
export const studentOrgId = ['minhang', 'szzyjsxy', 'sit_edu', 'shenzhen_xinxizhiye', 'shanwei_zhiye', 'xinan_xueyuan']

// 聊天类型
// chatSceneType    1 咨询师 2 客服 3 AI
export const CHAT_SCENE_TYPE = {
  CHAT_THERAPIST: 1,
  CHAT_SERVICE: 2,
  CHAT_AI: 3
}

export const SERVICE_TYPE = { 1: '电话咨询', 2: '视频咨询', 3: '来公司咨询', 4: '驻场咨询' };
// 1未分配， 2 已分配，3 已完成，4分配后已取消 ， 5 分配前已取消';--合并4,5
export const APPOINTMENT_STATUS = { 1: '未分配', 2: '已分配', 3: '已完成', 4: '已取消', 5: '已取消' };
// 咨询语言类型
export const LANGUAGE_TYPE = { 1: '中文咨询', 2: '英文咨询' }

// 认知游戏的音频base地址
export const COGNITION_BASE_URL = 'https://image.siuvo.com.cn/games/voice/';

// 员工心理测评量表包
export const EAP_SCALE_PACKAGE_SCENE_ID = ['1c72cba68f1943c', '727253d0325e459', 'a61f02cb349b420', 'd85c7f8afc004e1']
